import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getPaymentInformationSelector } from '../selectors'
import { IPaymentInformationState } from '../store/paymentInformation.types'
import { setPriorAuthorizationPayer } from '../store/paymentInformation.actions'
import { OptionsConstants } from '../../options/store/options.constants'
import { IPaymentInformationOptionState } from '../../options/store/options.types'
import { getPaymentInformationOptionsSelector } from '../../options/selectors'

export function* removePriorAuthorizationPayer() {
  try {
    const paymentInformationState: IPaymentInformationState = yield select(getPaymentInformationSelector)
    const { priorAuthorizationPayer } = paymentInformationState
    const paymentInformationOptions: IPaymentInformationOptionState = yield select(getPaymentInformationOptionsSelector)
    const { priorAuthorizationPayerOptions } = paymentInformationOptions

    if (
      priorAuthorizationPayer &&
      priorAuthorizationPayerOptions.findIndex((option) => option.id === priorAuthorizationPayer.id) === -1
    ) {
      yield put(setPriorAuthorizationPayer(null))
    }
  } catch (e) {
    yield put(throwPcrException(`removePriorAuthorizationPayer() error: ${e}`))
  }
}
export function* removePriorAuthorizationPayerSaga() {
  yield takeLatest([OptionsConstants.SET_PRIOR_AUTHORIZATION_PAYER_OPTIONS], removePriorAuthorizationPayer)
}
